// GoogleLoginButton.js
// Public user Google OAuth login button for job portal
// To be implemented: Google OAuth logic


import React, { useEffect } from 'react';
import axios from 'axios';
import './GoogleLoginButton.css';


// NOTE: You must set up a Google Client ID and add the Google Identity Services script in your index.html
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const GoogleLoginButton = () => {
  useEffect(() => {
    if (!window.google && window.document) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleGoogle = () => {
    if (!window.google || !GOOGLE_CLIENT_ID) {
      alert('Google login not configured');
      return;
    }
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: async (response) => {
        try {
          // Decode JWT to get user info (or send to backend for verification)
          const apiUrl = process.env.REACT_APP_API_URL || '/api';
          const res = await axios.post(`${apiUrl}/publicuser/google`, {
            googleId: response.credential, // send credential to backend
            // Optionally decode JWT for name/email
          });
          alert(res.data.message || 'Google login successful!');
        } catch (err) {
          alert(err.response?.data?.error || 'Google login failed');
        }
      }
    });
    window.google.accounts.id.prompt();
  };

  return (
    <div className="google-login-btn-container">
      <button className="google-login-btn" onClick={handleGoogle}>
        <span className="google-icon" aria-hidden="true">
          {/* Google SVG icon */}
          <svg width="22" height="22" viewBox="0 0 48 48"><g><path fill="#4285F4" d="M24 9.5c3.54 0 6.7 1.22 9.19 3.23l6.85-6.85C35.97 2.7 30.36 0 24 0 14.82 0 6.73 5.82 2.69 14.09l7.99 6.2C12.13 13.13 17.62 9.5 24 9.5z"/><path fill="#34A853" d="M46.1 24.55c0-1.64-.15-3.22-.42-4.74H24v9.01h12.42c-.54 2.9-2.18 5.36-4.65 7.01l7.19 5.59C43.98 37.13 46.1 31.3 46.1 24.55z"/><path fill="#FBBC05" d="M10.68 28.29c-1.01-2.99-1.01-6.21 0-9.2l-7.99-6.2C.86 16.18 0 19.01 0 22c0 2.99.86 5.82 2.69 8.11l7.99-6.2z"/><path fill="#EA4335" d="M24 44c6.36 0 11.97-2.1 15.85-5.74l-7.19-5.59c-2.01 1.35-4.59 2.13-8.66 2.13-6.38 0-11.87-3.63-13.32-8.79l-7.99 6.2C6.73 42.18 14.82 48 24 48z"/><path fill="none" d="M0 0h48v48H0z"/></g></svg>
        </span>
        <span>Sign in with Google</span>
      </button>
    </div>
  );
};

export default GoogleLoginButton;
